import { useParams } from 'react-router-dom';
import api from 'api';
import { toast } from 'react-toastify';
import './report-download.scss';

function ReportDownload() {
    const params: any = useParams();

    var fileFormat = "application/pdf";

    if (params.layoutId === 2){
        fileFormat = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }

    api.report.download(params.guid, fileFormat)
    .then(() => {
        toast.success(`Downloaded`); return; 
    }).catch(err => {
        toast.error(err.toString());
    })

    return (
        <div id={'report-download'} className={'container'}>
            <i className="fal fa-spinner fa-spin fa-5x"></i>
        </div>
    )
}

export default ReportDownload;
